module.exports = __webpack_public_path__ + "static/img/JN2E3877-2-1080p.7c6182c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio4/JN2E3877-2-1080p.jpg
// module id = pLkp
// module chunks = 0